module.exports = __webpack_public_path__ + "static/media/amazon-services.409ec6fe.png";